import {
  getAbsorbanceValue,
  getCurrentAriaLabel,
  getSwitchButtonAriaLabels,
  getWaveLengthRange,
  getAriaLableList,
  updateSwitchButtons,
} from "./Main.utils";
import absorbanceValues from "../../Data/absData.json";
import sceneData from "../../Data/scene.json";

export const REDUCER_DEFAULT = {
  ariaLabels: {},
  ariaLabel: { content: "aria-label" },
  orientation: "square",
  wavelengthSliderText: "",
  wavelengthSlider: {
    scaleInterval: 40,
    min: 380,
    max: 740,
    step: 40,
    keyboardStep: "auto",
    current: 380,
  },
  absorbanceSliderText: "",
  absorbanceSlider: {
    scaleInterval: 0.5,
    min: 5,
    max: 8,
    step: 0.5,
    current: 5,
  },
  waveLengthRange: 0,
  absValue: 0,
  phAbsorbanceData: [
    {
      ph: 8,
      nm: 380,
      abs: 0.4682,
      color: {
        r: 255,
        g: 0,
        b: 255,
      },
    },
  ],
  showTableToggle: true,
  rangeTableToggle: true,
  switchButtons: [
    {
      name: "switch_option",
      value: "ph_absorbance",
      checked: true,
      label: "",
    },
    {
      name: "switch_option",
      value: "range",
      checked: true,
      label: "",
    },
  ],
};

export const ACTION = {
  FETCH_DATA_SUCCESS: "FETCH_DATA_SUCCESS",
  ANIMATION_LOADED: "ANIMATION_LOADED",
  ON_CHANGE_WAVELENGTH_SLIDER: "ON_CHANGE_WAVELENGTH_SLIDER",
  ON_CHANGE_ABSORBANCE_SLIDER: "ON_CHANGE_ABSORBANCE_SLIDER",
  ON_TOGGE_SWITCH: "ON_TOGGE_SWITCH",
};

export function Reducer(state, action) {
  switch (action.type) {
    case ACTION.FETCH_DATA_SUCCESS:
      return handleFetchSuccess(state);
    case ACTION.ANIMATION_LOADED:
      return handleAnimationLoaded(state, action.payload);
    case ACTION.ON_CHANGE_WAVELENGTH_SLIDER:
      return handleOnChangeWavelengthSlider(state, action.payload);
    case ACTION.ON_CHANGE_ABSORBANCE_SLIDER:
      return handleOnChangeAbsorbanceSlider(state, action.payload);
    case ACTION.ON_TOGGE_SWITCH:
      return handleOnToggleSwitch(state, action.payload);
    default:
      return state;
  }
}

function handleFetchSuccess(state) {
  const loading = false;
  const error = false;
  const ariaLabels = getAriaLableList(sceneData.customData);
  const ariaLabel = getCurrentAriaLabel(
    ariaLabels.sliderLabels,
    state.wavelengthSlider.current,
    state.absorbanceSlider.current,
    state.ariaLabel
  );
  ariaLabel.content = ariaLabels.content;
  const switchButtons = getSwitchButtonAriaLabels(
    sceneData.togglesAltText,
    state.switchButtons
  );
  const phAbsorbanceData = getAbsorbanceData(state.wavelengthSlider.current);
  return {
    ...state,
    ariaLabels,
    ariaLabel,
    switchButtons,
    loading,
    error,
    phAbsorbanceData,
  };
}

function handleAnimationLoaded(state) {
  const ariaLabel = getCurrentAriaLabel(
    state.ariaLabels.sliderLabels,
    state.wavelengthSlider.current,
    state.absorbanceSlider.current,
    state.ariaLabel
  );
  return { ...state, ariaLabel: { ...state.ariaLabel, ...ariaLabel } };
}

function handleOnChangeWavelengthSlider(state, payload) {
  const wavelengthSlider = { ...state.wavelengthSlider, current: payload };
  const waveLengthRange = Math.round(
    getWaveLengthRange(wavelengthSlider.current)
  );
  const ariaLabel = getCurrentAriaLabel(
    state.ariaLabels.sliderLabels,
    payload,
    state.absorbanceSlider.current,
    state.ariaLabel
  );
  const phAbsorbanceData = getAbsorbanceData(wavelengthSlider.current);
  return {
    ...state,
    wavelengthSlider,
    waveLengthRange,
    phAbsorbanceData,
    ariaLabel: { ...state.ariaLabel, ...ariaLabel },
  };
}

function handleOnChangeAbsorbanceSlider(state, payload) {
  const absorbanceSlider = { ...state.absorbanceSlider, current: payload };
  const absValue = Math.round(getAbsorbanceValue(absorbanceSlider.current));
  const ariaLabel = getCurrentAriaLabel(
    state.ariaLabels.sliderLabels,
    state.wavelengthSlider.current,
    payload,
    state.ariaLabel
  );
  return {
    ...state,
    absorbanceSlider,
    absValue,
    ariaLabel: { ...state.ariaLabel, ...ariaLabel },
  };
}

function handleOnToggleSwitch(state, payload) {
  const switchButtons = updateSwitchButtons(state.switchButtons, payload);
  let phAbsorbanceData = {};
  if (switchButtons[0].checked) {
    state.showTableToggle = true;
    phAbsorbanceData = getAbsorbanceData(state.wavelengthSlider.current);
  } else {
    state.showTableToggle = false;
  }
  if (switchButtons[1].checked) {
    state.rangeTableToggle = true;
    phAbsorbanceData = getAbsorbanceData(state.wavelengthSlider.current);
  } else {
    state.rangeTableToggle = false;
  }
  return { ...state, switchButtons, phAbsorbanceData };
}

function getAbsorbanceData(currentWaveLength) {
  const filteredData = absorbanceValues.filter(function (items) {
    return items.nm === currentWaveLength;
  });
  return filteredData;
}
